import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { priceTypes, priceActions } = createActionsStructure('price', [
  { name: 'GET_PRICES', async: true },
  { name: 'CLEAR_PRICES', async: false },
  { name: 'CHANGE_PRICE', async: false },
  { name: 'SET_PRICE', async: true },
  { name: 'GET_CITIES_ROUTE_PRICE', async: true },
  { name: 'CLEAR_CITIES_ROUTE_PRICE', async: false }
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/PriceActions.js